import React from 'react'
import { useTranslation } from 'react-i18next'
import { Message } from '@resultadosdigitais/tangram-components'

const MFAauthAppReminder = () => {
  const { t } = useTranslation()
  return <Message title={t('MFAauthAppReminder.Description')} kind={Message.kinds.warning} dismissible={false} />
}

export default MFAauthAppReminder
